<div class="modal-header">
  <h4 class="modal-title">Rename Product</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="flex flex-row pb-3">
    <div>
      <div class="flex flex-row space-x-4">
        <div class="dx-field flex">
          <div class="pt-2 pr-[21px] pb-2 pl-0">Product:</div>
          <div class="dx-field-value">
            <dx-text-box [value]="selectedEditProductOldName" [readOnly]="true"></dx-text-box>
          </div>
        </div>
        <div class="dx-field flex">
          <div class="pt-2 pr-1 pb-2 pl-0">Id:</div>
          <div class="dx-field-value">
            <dx-text-box [value]="productId" [readOnly]="true"></dx-text-box>
          </div>
        </div>
      </div>
      <div class="flex flex-row space-x-4">
        <div class="dx-field flex">
          <div class="pt-2 pr-1 pb-2 pl-0">Change To:</div>
          <div class="dx-field-value">
            <dx-text-box [value]="selectedEditProductNewName" valueChangeEvent="keyup" (onValueChanged)="valueChanged($event)">
              <dx-validator>
                <dxi-validation-rule 
                    type="required" 
                    message="Field is required">
                </dxi-validation-rule>
              </dx-validator>
            </dx-text-box>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex flex-col">
    <h4>Affected Product Relations with Current OLD Brand Name</h4>
    <div class="pb-3">
      <dx-data-grid
        [dataSource]="affectedEditProductNameData" 
        [showBorders]="true" 
        [columnAutoWidth]="true" 
      >
        <dxi-column dataField="ProductRelationId" caption="Product Relation Id" [customizeText]="customizeProductId"></dxi-column>
        <dxi-column dataField="CompanyName" caption="Company"></dxi-column>
        <dxi-column dataField="MasterBrandName" caption="Master Brand"></dxi-column>
        <dxi-column dataField="BrandName" caption="Brand"></dxi-column>
        <dxi-column dataField="SubBrandName" caption="SubBrand"></dxi-column>
        <dxi-column dataField="ProductName" caption="Product"></dxi-column>
      </dx-data-grid>
    </div>
    <h4>Other existing Product Relations with intended NEW Brand Name</h4>
    <div>
      <dx-data-grid
        #existingProductNameGrid
        id="existingProductNameGrid"
        [dataSource]="existingEditProductNameData" 
        [showBorders]="true" 
        [columnAutoWidth]="true" 
      >
        <dxi-column dataField="ProductRelationId" caption="Brand Relation Id"></dxi-column>
        <dxi-column dataField="CompanyName" caption="Company"></dxi-column>
        <dxi-column dataField="MasterBrandName" caption="Master Brand"></dxi-column>
        <dxi-column dataField="BrandName" caption="Brand"></dxi-column>
        <dxi-column dataField="SubBrandName" caption="SubBrand"></dxi-column>
        <dxi-column dataField="ProductName" caption="Product"></dxi-column>
      </dx-data-grid>
    </div>
  </div>
</div>
<div class="modal-footer">
  <dx-button
    icon="check"
    type="success"
    text="Rename"
    (onClick)="rename()"
  >
  </dx-button>
  <dx-button
    icon="close"
    text="Cancel"
    (onClick)="activeModal.dismiss('Cross click')"
  >
  </dx-button>
</div>